export const TableType = {
  OFFERS_LIST: 'OFFERS_LIST',
  SOURCING_OFFER_LIST: 'SOURCING_OFFER_LIST',
}
